import { render, staticRenderFns } from "./PunchButton.vue?vue&type=template&id=1ca3999c&scoped=true&"
import script from "./PunchButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./PunchButton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PunchButton.vue?vue&type=style&index=0&id=1ca3999c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3999c",
  null
  
)

export default component.exports